
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 480.35 480.35"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M171.821 10.011a239.995 239.995 0 00-131.806 97.671 65.273 65.273 0 00-7.84 24.96v-84.32h-32v128h128v-32h-72.32c35.828-68.925 106.646-112.572 184.32-113.6 92.115 1.071 172.856 61.854 199.36 150.08l30.72-9.12C432.489 44.627 298.876-27.755 171.821 10.011zm180.354 294.311v32h72.32c-35.828 68.925-106.646 112.572-184.32 113.6-92.115-1.071-172.856-61.854-199.36-150.08l-30.72 9.12c37.928 127.006 171.634 199.218 298.64 161.29a239.998 239.998 0 00134.32-101.93 43.998 43.998 0 005.12-20.32v84.32h32v-128h-128z"}})])
          )
        }
      }
    